import axios from "../axiosPlugin.js";

const _OTHER_GOODS_API = "/api/otherGoods";

export const getOtherGoodsListService = data => {
  return axios({
    url: `${_OTHER_GOODS_API}/list`,
    method: "get",
    data: { data },
  });
};

export const approveOtherGoodsService = data => {
  return axios({
    url: `${_OTHER_GOODS_API}/approve?cinemaId=${data.cinemaId}`,
    method: "post",
    data: { data },
  });
};

export const addOtherGoodsService = data => {
  return axios({
    url: `${_OTHER_GOODS_API}/create`,
    method: "post",
    data: { data },
  });
};
export const OtherGoodsServiceDetail = data => {
  return axios({
    url: `${_OTHER_GOODS_API}/detail/${data.id}`,
    method: "get",
    data: {},
  });
};
export const updateOtherGoodsService = data => {
  return axios({
    url: `${_OTHER_GOODS_API}/update`,
    method: "post",
    data: { data },
  });
};

export const deleteOtherGoodsService = data => {
  return axios({
    url: `${_OTHER_GOODS_API}/delete/${data.id}`,
    method: "get",
    data: { data },
  });
};